import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import Footer from '../../components/Layout/Footer';
import ContactMain from './ContactMain';

// Breadcrumbs Background Image

const Contact = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
            <Helmet>
                <title>Contact Us - U Brand It Promotional Products</title>
                <meta name="description" content="Contact U Brand It for custom promotional products and branded merchandise. Call 800-721-5822 or fill out our form for a free quote. We're here to help!" />
                <meta name="keywords" content="contact U Brand It, promotional products quote, custom merchandise, branded products, business promotional items" />
                <link rel="canonical" href="https://ubranditpa.com/contact" />
                
                {/* Open Graph */}
                <meta property="og:title" content="Contact Us - U Brand It Promotional Products" />
                <meta property="og:description" content="Contact U Brand It for custom promotional products and branded merchandise. Call 800-721-5822 or fill out our form for a free quote." />
                <meta property="og:url" content="https://ubranditpa.com/contact" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header
                navImg={navImg1}
                parentMenu='contact'
                activeMenu="/contact"
            />
            <ContactMain/>
            <BackToTop scroll={isVisible} />
            <Footer />
        </React.Fragment>
    );
}

export default Contact;